import CompletedTaskData from './CompletedTaskData.js';

const CreateTask = () => {
return(
    <CompletedTaskData/>
)
}

export default CreateTask;
